<template>
  <div class="parent">
    <button class="box-button-scroll-to-top" @click="scrollToTop"><i class="el-icon-top"></i></button>
  </div>
</template>

<script>
export default {
  name: 'ButtonScrollToTop',
  methods: {
    scrollToTop () {
      this.$emit('goToTop', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.parent{
  position: fixed;
  bottom: 90px;
  right: 60px;
  width: 50px;
  height: 50px;
  background-color: white;
  color: #0AB1BF;
  border-radius:50%;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  .box-button-scroll-to-top {
    outline: none;
    position: absolute;
    top:55%;
    left: 49%;
    transform: translate(-50%, -50%);
    i {
      font-size: 1.8em;
      font-weight: 700;
    }
    &:hover{
      opacity: .5;
    }
  }
  &:hover{
    border: 1px solid #0AB1BF;
  }
}
</style>
